<template>
  <div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="Year / Năm" prop="year">
        <a-select v-model="form.year" placeholder="Select year">
          <a-select-option
            v-for="i in 5"
            :key="+now.year() - i"
            :disabled="disabledYearExits(annualLeaveYears, +now.year() - i)"
          >
            {{ +now.year() - i }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        label="Original / Ngày nghỉ phép năm ban đầu"
        prop="original"
      >
        <a-input-number
          v-model="form.original"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
        />
      </a-form-model-item>

      <a-form-model-item
        label="Total working hour in day / Tổng giờ ca làm việc"
        prop="totalWorkingHoursPerDay"
      >
        <a-input-number
          v-model="form.totalWorkingHoursPerDay"
          placeholder="Enter number..."
          style="width: 100%;"
          :min="1"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
        />
      </a-form-model-item>

      <a-form-model-item
        label="Total annual leave / Tổng ngày phép năm"
        prop="total"
      >
        <a-input-number
          v-model="form.total"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          @change="
            () => {
              form.unused = form.total - form.used;
            }
          "
        />
      </a-form-model-item>

      <a-form-model-item
        label="Used / Tổng ngày phép năm đã sử dụng"
        prop="used"
      >
        <a-input-number
          v-model="form.used"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          @change="
            () => {
              form.unused = form.total - form.used;
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item prop="unused">
        <span slot="label">
          Unused / Tổng ngày phép năm chưa sử dụng: {{ form.unused || "" }}
        </span>
        <!-- <a-input-number
          v-model="form.unused"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : value < 0
                ? `- ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : value
          "
        /> -->
      </a-form-model-item>
    </a-form-model>
    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="close" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import queryAnnualLeaveYear from "../../Constants/queryAnnualLeaveYear";
// import { workingHourInDay } from "../../data/default";

const rules = {
  year: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  original: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  totalWorkingHoursPerDay: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  total: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  unused: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  used: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
};

const DEFAULT_VALUE = { totalWorkingHoursPerDay: 8 };

function disabledYearExits(annualLeaveYears, year) {
  if (
    annualLeaveYears?.length > 0 &&
    annualLeaveYears.findIndex((e) => e.year === year) >= 0
  ) {
    return true;
  }
  return false;
}

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    refreshAfterCreated: {
      type: Function,
      default: () => {},
    },
    annualLeaveYears: {
      type: Array,
      default: () => {
        return [];
      },
    },
    employee: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      now: moment(),
      form: { ...DEFAULT_VALUE },
      loadingBtn: false,
    };
  },
  methods: {
    disabledYearExits,
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreateEmployeeAnnualLeaveYear();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onCreateEmployeeAnnualLeaveYear() {
      this.loadingBtn = true;
      const workShift =
        this.employee.workShift ||
        this.employee?.branchLocation?.mainShift ||
        {};
      this.$apollo
        .mutate({
          mutation: queryAnnualLeaveYear.createEmployeeAnnualLeaveYear,
          variables: {
            ...this.form,
            total: +this.form.total * +this.form.totalWorkingHoursPerDay,
            unused: +this.form.unused * +this.form.totalWorkingHoursPerDay,
            used: +this.form.used * +this.form.totalWorkingHoursPerDay,
            original: +this.form.original * +this.form.totalWorkingHoursPerDay,
            employeeId: this.$route.params.idEmployee,
          },
        })
        .then(({ data }) => {
          if (data?.createEmployeeAnnualLeaveYear) {
            this.refreshAfterCreated(data.createEmployeeAnnualLeaveYear);
          }
          this.close();
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.error("Lỗi thêm mới", err);
        });
    },
  },
};
</script>
